import * as actions from '../actions'

const defaultState = {
    rows: [],
    total: 0,
    limit: 50,
    offset: 0,
    error: null
}

export default function hsmList(state = defaultState, action) {
    switch (action.type) {
        case actions.GET_HSM_LIST:
            if (action.error) {
                return Object.assign({}, state, {
                    error: (action.payload && action.payload.message) || 'Error'
                })
            }
            return Object.assign({}, state, {
                error: null,
                rows: (action.payload && action.payload.data && action.payload.data.rows) || [],
                total: (action.payload && action.payload.data && action.payload.data.total) || 0,
                limit: (action.payload && action.payload.data && action.payload.data.limit) || state.limit,
                offset: (action.payload && action.payload.data && action.payload.data.offset) || 0
            })

        case actions.CLEAN_HSM_LIST:
            return defaultState

        default:
            return state
    }
}
